var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgColumnIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.99967 0.666015L0.666341 0.666015L0.66634 11.3327L11.333 11.3327L11.333 0.666016L5.99967 0.666015ZM9.33301 10.5729L8.04223 10.5729L8.04223 1.42575L10.6238 1.42575L10.6238 10.5729L9.33301 10.5729ZM6.02804 10.5729L4.72308 10.5729L4.72308 1.42575L6.00925 1.42575C6.71634 1.42575 7.30358 1.43487 7.31421 1.44588C7.3245 1.45728 7.33301 3.5154 7.33301 6.01948L7.33301 10.5729L6.02804 10.5729ZM2.66634 10.5729L1.37556 10.5729L1.37556 1.42575L3.95712 1.42575L3.95712 10.5729L2.66634 10.5729Z",
    fill: "black"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgColumnIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Column_Icon.7153129b67a3355a7cb5e57587cdfa91.svg";